<template>
  <div id="approval-form" class="space-y-6 border-t border-gray-200 pt-6">
    <h2 class="text-lg font-medium text-gray-900">Configuración de Aprobación</h2>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="flex items-center space-x-3">
            <span class="text-sm font-medium text-gray-700">Es privado</span>
          </label>
          <b-form-checkbox
            type="checkbox"
            class="h-4 w-4 text-blue-600 border-gray-300 rounded"
            v-model="state.isPrivate"
            switch
            inline
          />

        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Ejecutar como persona que lanza el evento
          </label>
          <b-form-checkbox
            v-model="state.fromOrigingUser"
            name="is-vertical-menu-collapsed"
            class="mr-0"
            switch
            inline
          />
        </div>
      </div>
    </div>
    <!-- Name Input -->
    <div class="form-group">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Nombre (*)
      </label>
      <Taggeable
        :keys="['{{']"
        :items="tags"
      >
        <b-form-textarea-tags
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg"
          placeholder="Ingrese el nombre"
          v-model="state.name"
          maxlength="300"
          :tags="tags"
          rows="1"
        />
      </Taggeable>
    </div>
    <!-- Description Input -->
    <div class="form-group">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Descripción (*)
      </label>
      <Taggeable
        :keys="['{{']"
        :items="tags"
      >
        <b-form-textarea-tags
          type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-lg"
          placeholder="Ingrese descripción"
          v-model="state.description"
          maxlength="500"
          :tags="tags"
          rows="2"
        />
      </Taggeable>
    </div>

    <!-- Flow Selection -->
    <div class="form-group">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Flujo a utilizar (*)
      </label>
      <ListAprovals
        class="w-100 mb-0"
        autocomplete
        label=""
        status="Y"
        reference="ARCHIVO,ARCHIVO-RP"
        name="approvals"
        v-model="state.flow"
        data-vv-as="flujo"
      />
    </div>
  </div>
</template>
<script>

import Vue from 'vue';
import { BFormCheckbox } from 'bootstrap-vue';

import ListAprovals from '@/febos/chile/lists/components/ListAprovals';
import BFormTextareaTags from '@/febos/global/_vue/componentes/BFormTextareaTags';
import Taggeable from '@/febos/global/billing/components/Taggeable';
import { jsonPathTypes } from '@/febos/global/rules/util/rules';

export const ApprovalConfigForm = {
  name: 'ApprovarConfigForm',
  data() {
    return {
      jsonPathTypes,
    };
  },
  computed: {
    Vue() {
      return Vue;
    },
    tags() {
      return this.jsonPathTypes.map((type) => ({
        value: `{{${type.value}}}`,
        label: type.label,
        example: type.label
      }));
    }
  },
  components: {
    BFormCheckbox, Taggeable, ListAprovals, BFormTextareaTags
  },
  props: {
    state: {
      type: Object,
      default: () => ({})
    }
  }

};
export default ApprovalConfigForm;
</script>
<style scoped>

</style>
